export const LOOKUP_TYPE = {
  SMS_MAPPING_KEY: "SmsMappingKeys",
  SMS_MAPPING_KEY_LANGS: "SmsMappingKeyAllLangs",
  CONFIRM_EMAIL_TIME: "ConfirmEmailTime",
  CONFIRM_SMS_TIME: "ConfirmSmsTime",
  CONFIRMATION_TYPE: "ConfirmationTypes",
  OWNER_CONFIRMATION_TYPE: "OwnerConfirmTypes",
  CONFIRMATION_MESSAGE: "ConfirmationMessages",
  CONFIRMATION_ALARM: "ConfirmationAlarm",
  SMS_TEMPLATE_TYPE: "SmsTemplateTypes",
  PRE_CONFIRMATION: "Preconfirmation",
  CHECKUP: "Checkup",
  LOOKUP_SOCIAL_TYPE: "SocialType",
  FLOOR_PLAN: "FloorPlan",
  CONFIRM_TEMPLATES: 'NewTemplate',
  LOOKUP_SOCIAL_PROPERTY_TEMPLATE: "SocialTemplate",
  LOOKUP_SOCIAL_PROJECT_TEMPLATE: "SocialProjectTemplate",
  PUBLISH_UNIT_TYPE_ON_PORTAL: "PublishUnitTypeOnPortal",

  //#region common
  ObjectGoal: "ObjectGoal",
  Manager: "Manager",
  SinceDate: 'SinceDate',

  //#endregion
  //#region property
  TypeOfProperty: "TypeOfProperty",
  AddressTitle: "AddressTitle",
  DocumentTypes: "DocumentTypes",
  DocumentPublish: "DocumentPublish",
  PictureGroups: "PictureGroups",
  PropertyStatus: "Status",
  PropertySubStatus: "SubStatus",
  PropertStatusForSearch: "StatusForSearch",
  //#endregion

  //#region person
  PersonType: "PersonType",
  Company: "Companies",
  C21Profession: "C21Profession",
  Category: "category",
  City: "City",
  CompanyDepartment: "CompanyDepartment",
  Country: "Country",
  LetterTitle: "LetterTitle",
  MaritalStatus: "MaritalStatus",
  PersonSource: "PersonSource",
  PersonFunction: "PersonFunction",
  PersonStatus: "PersonStatus",
  PhoneDescription: "PhoneDescription",
  PreConfirmation: "PreConfirmation",
  PreferredMedium: "PreferedMedium",
  RelationType: "RelationType",
  RelationReverseType: "RelationReverseType",
  //#endregion

  //#region demand
  DemandStatus: "DemandStatus",
  DemandPurpose: "DemandPurpose",
  RearOrientation: "RearOrientation",
  //#endregion

  //#region task
  Site: "Site",
  TaskType: "TaskType",
  DurationTask: "DurationTask",
  TaskGroup: 'TaskGroup',
  Month: 'Month',
  PersonSite: 'PersonSite',
  PropertySite: 'PropertySite',
  DemandSite: 'DemandSite',
  //#endregion

  // Lookup data for Property
  PropertyEnvironment: "Environment",

  ListOfCondition: "Condition",
  ListOfConstruction: "Construction",
  ListOfConstructionType: "ConstructionType",
  ListOfExteriorcomfort: "ExteriorComfort",
  ListOfGoal: "Goal",
  ListOfHeating: "Heating",
  ListOfHeatingb: "HeatingB",
  ListOfInteriorcomfort: "InteriorComfort",
  ListOfKitchen: "Kitchen",
  ListOfRearorientation: "RearOrientation",
  ListOfRoofmaterial: "RoofMaterial",
  ListOfRoof: "Roof",
  ListOfStyle: "Style",

  ListOfRoofCondition: "RoofCondition",
  ListOfWindowsGlazing: "WindowsGlazing",
  ListOfWindowFrame: "WindowFrame",

  ListOfEPCLuxembourg: "EPCLuxembourg",
  ListOfCO2Luxembourg: "CO2Luxembourg",
  ListOfInsulationLuxembourg: "InsulationLuxembourg",

  //#region property-relation
  ListOfMandateType: "TypeOfMandate",
  ListOfProlongationType: "ProlongationType",
  ListOfCommissionType: "CommissionType",
  ListOfDepositType: "DepositType",
  ListOfPersonType: "PersonType",
  ListOfConfirmEmailTime: "ConfirmEmailTime",
  ListOfParticularConditionClause: "ParticularConditionClause",
  ListOfPrePaymentType: "PrePayType",
  ListOfImmoWebOption: "ImmoWebOption",
  ListOfImmowebDetailedPage: "ImmowebDetailedPage",
  ListOfPublishOnMedia: "PublishOnMedia",
  ListOfFinanceReduction: "FinanceReduction",
  //#endregion
  constructionViewType: "constructionViewType",
  projectStatus: "projectStatus",
  rentals: "Rentals",
  reductionType: "ReductionType",
  freeAvailable: "FreeAvalable",
  projectPhase: "ProjectPhase",
  projectUsage: "ProjectUsage",
  HistoryType: "HistoryType",

  Gender: "Gender",
  CardType: "CardType",
  CardSpecialStatus: "CardSpecialStatus",
  PriceUnit: "PriceUnit",
  PropertyCategoryType: "PropertyCategoryType",

  CompanyLegalForm: 'CompanyLegalForm',
  TypeOfCompany: 'TypeOfCompany',
  RentToCompany: 'RentToCompany',

    CommissionType2: 'CommissionType2',
    CommissionRegion: 'CommissionRegion',
    CommissionRuleType: 'CommissionRuleType',
    TypeOfContract: 'TypeOfContract',
    AllowStatus: 'AllowStatus',
    AgendaStartTime: 'AgendaStartTime',
    AuthMode: 'AuthMode',
    ShowAppointmentOrTaskType: 'ShowAppointmentOrTaskType',
    FontWeighType: 'FontWeighType',
    DefaultAlarm: 'DefaultAlarm',

    TreviPartners: 'TreviPartners',
    CostType: 'CostType',

    TypeSign: 'TypeSign',
    SignStatus: 'SignStatus',
    GoogleAnalyticsApiVersion: 'GoogleAnalyticsApiVersion',
    REASONLOST: 'ReasonLost',
    SOURCECONTACT: 'SourceContact',
    CANCELEDREASON: 'CanceledReason',
};

export const LOOKUP_COLOR_TYPE = {
    SubStatus: 'SubStatus',
    TypeOfMandate: 'TypeOfMandate'
}